import { Collapse, Drawer as MuiDrawer, List as MuiList, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import MenuItem from './MenuItem';
import { MCE_GREY } from './theme';

interface DrawerProps {
  collapse: boolean;
}

const Drawer = styled(MuiDrawer, {
  // The DOM does not recognize the boolean attribute 'collapse' so it should not be forwarded to avoid a console error.
  shouldForwardProp: prop => prop !== 'collapse'
})<DrawerProps>(props => ({
  flexShrink: 0,
  overflow: 'hidden',
  transition: 'width 225ms',
  width: props.collapse ? '80px' : '256px',

  '.MuiDrawer-paper': {
    transition: 'width 225ms',
    width: props.collapse ? '80px' : '256px'
  }
}));

const DrawerContainer = styled('div')({
  overflow: 'auto',
  backgroundColor: MCE_GREY,
  height: '100%',
  color: '#fff',
  paddingTop: '5px'
});

const List = styled(MuiList)({
  overflow: 'hidden',
  padding: '0px'
});

interface Props {
  isMobile: boolean;
  isDrawerOpen: boolean;
  onCloseDrawer: () => void;
  trigger: boolean;
  salesCount?: number;
  outOfStockCount?: number;
}

const MenuDrawer: React.FC<Props> = ({
  isMobile,
  isDrawerOpen,
  onCloseDrawer,
  trigger,
  salesCount
}) => {
  return (
    <Drawer
      anchor='left'
      open={isDrawerOpen}
      onClose={onCloseDrawer}
      variant={isMobile ? 'temporary' : 'permanent'}
      ModalProps={{
        keepMounted: true // Better open performance on mobile.
      }}
      collapse={!isDrawerOpen}
    >
      {!isMobile && (
        <Collapse in={!trigger} timeout={225}>
          <Toolbar />
        </Collapse>
      )}
      <DrawerContainer>
        <List>
          <MenuItem icon='CheckBox' to='/form'>
            Form
          </MenuItem>

          <MenuItem icon='Restore' to='/submitted'>
            Submitted
          </MenuItem>
        </List>
      </DrawerContainer>
    </Drawer>
  );
};

export default MenuDrawer;
